import { Controller } from "@hotwired/stimulus"

// Displays a loading overlay while cart mutations are processing.
export default class extends Controller {
  static targets = ["overlay"]

  show() {
    this.toggleOverlay(true)
  }

  hide() {
    this.toggleOverlay(false)
  }

  toggleOverlay(show) {
    if (!this.hasOverlayTarget) return

    this.overlayTarget.classList.toggle("hidden", !show)
    this.overlayTarget.setAttribute("aria-hidden", String(!show))
    this.element.setAttribute("aria-busy", String(show))
  }
}
